import React from 'react';
//import './Header.css';

function Header() {
  return (
    <header className="site-header">
      <img src="/logo.png" alt="Logo" className="logo" />
      <span className="site-title">Ulalaaa</span>
      <button className="publicar-btn">PUBLICAR TU AVISO</button>
    </header>
  );
}

export default Header;
